<template>
  <div>
    <Layout>
      <div class="row">
        <PageHeader class="col-11" title="Devices" />
      </div>

      <div class="row mt-4">
        <div class="col-sm-12 col-md-6">
          <div id="tickets-table_length" class="dataTables_length">
            <label class="d-inline-flex align-items-center">
              Show&nbsp;
              <b-form-select
                class="form-select form-select-sm"
                v-model="perPage"
                size="sm"
                :options="pageOptions"
              ></b-form-select
              >&nbsp;entries
            </label>
          </div>
        </div>
        <!-- Search -->
        <div class="col-sm-12 col-md-6">
          <div id="tickets-table_filter" class="dataTables_filter text-md-end">
            <label class="d-inline-flex align-items-center">
              Search:
              <b-form-input
                v-model="searchQuery"
                type="text"
                placeholder="Search..."
                class="form-control form-control-sm ms-2"
              ></b-form-input>
            </label>
          </div>
        </div>
        <!-- End search -->
      </div>
      <div class="table-responsive mb-0">
        <table class="table align-middle table-nowrap">
          <thead class="table-light">
            <tr>
              <th style="width: 20px"></th>
              <th class="align-middle">Device Id</th>
              <th class="align-middle">Device IP</th>
              <th class="align-middle">Device Name</th>
              <th class="align-middle">Device Type</th>
              <th class="align-middle">Device Location</th>
              <th class="align-middle">Status</th>
              <th class="align-middle">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, index) in filteredRows" :key="index">
              <td></td>
              <td>
                <a href="javascript: void(0);" class="text-body fw-bold">{{
                  data.device_id
                }}</a>
              </td>
              <td>
                <a href="javascript: void(0);" class="text-body fw-bold">{{
                  data.device_ip
                }}</a>
              </td>
              <td>{{ data.device_name }}</td>
              <td>{{ data.device_type }}</td>
              <td>{{ data.device_location }}</td>

              <td>
                <span
                  class="badge badge-pill badge-soft font-size-11"
                  :class="{
                    'badge-soft-success': `${data.status}` === 'true',
                    'badge-soft-danger': `${data.status}` === 'false',
                  }"
                >
                  {{ getDeviceStatus(data.status) }}</span
                >
              </td>
              <td>
                <!-- Button trigger modal -->
                <button
                  type="button"
                  class="btn btn-info btn-sm btn-rounded"
                  @click="$bvModal.show(data.device_id)"
                >
                  View Details
                </button>
              </td>
              <b-modal
                :id="String(data.device_id)"
                title="Device Details"
                size="x1"
                title-class="font-18"
                hide-footer
              >
                <div class="row">
                  <div class="col-xl-6">
                    <div class="card">
                      <div class="card-body">
                        <div class="table-responsive">
                          <table class="table mb-0">
                            <tbody>
                              <tr>
                                <th scope="row">Id</th>
                                <td>{{ data.id }}</td>
                              </tr>
                              <tr>
                                <th scope="row">Device Id</th>
                                <td>{{ data.device_id }}</td>
                              </tr>
                              <tr>
                                <th scope="row">Device IP</th>
                                <td>{{ data.device_ip }}</td>
                              </tr>
                              <tr>
                                <th scope="row">Device Name</th>
                                <td>{{ data.device_name }}</td>
                              </tr>
                              <tr>
                                <th scope="row">Device Port</th>
                                <td>{{ data.device_port }}</td>
                              </tr>
                              <tr>
                                <th scope="row">Status</th>
                                <td>{{ data.status }}</td>
                              </tr>
                              <tr>
                                <th scope="row">Latitude</th>
                                <td>{{ data.lat }}</td>
                              </tr>
                              <tr>
                                <th scope="row">Longitude</th>
                                <td>{{ data.lat }}</td>
                              </tr>
                              <tr>
                                <th scope="row">Group Id</th>
                                <td>{{ data.group_id }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="card">
                      <div class="card-body">
                        <div class="table-responsive">
                          <table class="table mb-0">
                            <tbody>
                              <tr>
                                <th scope="row">CPU Util</th>
                                <td>{{ data.cpu_util }}</td>
                              </tr>
                              <tr>
                                <th scope="row">Current Device Time</th>
                                <td>{{ data.current_device_time }}</td>
                              </tr>
                              <tr>
                                <th scope="row">Device Description</th>
                                <td>{{ data.device_description }}</td>
                              </tr>
                              <tr>
                                <th scope="row">Device Location</th>
                                <td>{{ data.device_location }}</td>
                              </tr>
                              <tr>
                                <th scope="row">Device Type</th>
                                <td>{{ data.device_type }}</td>
                              </tr>
                              <tr>
                                <th scope="row">Memory Usage</th>
                                <td>{{ data.memory_usage }}</td>
                              </tr>
                              <tr>
                                <th scope="row">Model Name</th>
                                <td>{{ data.model_name }}</td>
                              </tr>
                              <tr>
                                <th scope="row">Uptime</th>
                                <td>{{ data.uptime }}</td>
                              </tr>
                              <tr>
                                <th scope="row">Name</th>
                                <td>{{ data.name }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-modal>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row">
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-end">
            <ul class="pagination pagination-rounded mb-0">
              <!-- pagination -->
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
              ></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </Layout>
  </div>
</template>

<script>
import Layout from "@/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Devices",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      devices: null,
      searchQuery: "",
      totalRows: 1,
      currentPage: 1,
      pageOptions: [10, 25, 50, 100],
      perPage: 10,
    };
  },
  computed: {
    getDevices() {
      return this.$store.getters["gis/devices"];
    },
    filteredRows() {
      if (this.searchQuery) {
        return this.getDevices.filter((row) => {
          const deviceId = row.device_id.toString().toLowerCase();
          const deviceIp = row.device_ip.toString().toLowerCase();
          const deviceName = row.device_name.toString().toLowerCase();
          const deviceType = row.device_type.toString().toLowerCase();
          const deviceLocation = row.device_location.toString().toLowerCase();
          const deviceStatus = row.status.toString().toLowerCase();

          const searchTerm = this.searchQuery.toLowerCase();
          return (
            deviceId.includes(searchTerm) ||
            deviceIp.includes(searchTerm) ||
            deviceName.includes(searchTerm) ||
            deviceType.includes(searchTerm) ||
            deviceLocation.includes(searchTerm) ||
            deviceStatus.includes(searchTerm)
          );
        });
      } else {
        return this.getDevices;
      }
    },
  },
  components: {
    Layout,
    PageHeader,
  },
  methods: {
    getDeviceStatus(status) {
      return status ? "Enabled" : "Disabled";
    },
  },
  mounted() {
    this.totalRows = this.getDevices.length;
  },
};
</script>

<style>
.modal-dialog {
  height: 50%;
  margin: 10%;
  padding: 0;
  max-width: 100vw;
}
.modal-content {
  height: auto;
  min-height: 100%;
  border-radius: 0;
}
</style>
